import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertService } from '@app/services/Alert/alert.service';
import { Subscription } from 'rxjs';

@Component({ selector: 'alert', templateUrl: 'alert.component.html' })
export class AlertComponent implements OnInit, OnDestroy {
    private subscription!: Subscription;
    alert: any;

    constructor(private alertService: AlertService) {}

    ngOnInit() {
        this.subscription = this.alertService.onAlert()
            .subscribe(alert => {
                switch (alert?.type) {
                    case 'success':
                        alert.cssClass = 'alert alert-success';
                        break;
                    case 'error':
                        alert.cssClass = 'alert alert-danger';
                        break;
                    case 'warn':
                        alert.cssClass = 'alert alert-warning';
                        break;
                    case 'info':
                        alert.cssClass = 'alert alert-info';
                        break;
                }

                this.alert = alert;

                setTimeout(() => {
                    alert = 'false';
                }, 10000);
            });
    }
    
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}